// extracted by mini-css-extract-plugin
module.exports = {"standardFeatures":"accessories__standardFeatures__hA47r"};